module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "partno"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('i', [_vm._v("PART ONE")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "parttitle"
  }, [_vm._v("DESCENT INTO DARKNESS")]), _vm._v(" "), _c('p', {
    staticClass: "imagea"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/sta.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "parttitlea"
  }, [_c('b', [_vm._v("1997-2001")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('i', [_vm._v("“Darkness cannot drive out darkness, only light can do that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "deda"
  }, [_c('b', [_vm._v("–M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTIN")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHER")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ING")]), _vm._v(", J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55742a44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/12_Part01.vue
// module id = 93
// module chunks = 0